export const GET_AUDIT_LOGS = "GET_AUDIT_LOGS";
export const GET_AUDIT_STATS = "GET_AUDIT_STATS";
export const GET_COIN_LEADERBOARD = "GET_COIN_LEADERBOARD";
